module.exports = __webpack_public_path__ + "static/media/icon-check-stroke.10bd74e8.svg";